import { Button, Col, Form, Modal, Row } from "react-bootstrap";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { notify } from "../actions/CommonActions";

export const ModalPremiumNotification = ({
    show,
    toggle,
    handleUploadFile,
    date,
    time,
    setDate,
    setTime,
    handleFileChange,
    note,
    setNote,
    setName,
    setChannel,
    setScheduleType,
    allTemplates,
    setScheduleMins,
    setTemplateType,
    scheduleType
}) => {

    const navigate = useNavigate();
    const [proceed, setProceed] = useState(false)
    const channelsAvailable = ["sms", "email", "push"]
    const scheduleAvailable = ["now", "later", "specific"]
    return (
        <Modal show={show} onHide={toggle} backdrop="static" keyboard={false}>
            <Modal.Header closeButton>
                <div>
                    <Modal.Title>Debit Mandate</Modal.Title>
                </div>
            </Modal.Header>
            {!proceed && <div>
                <Modal.Body>
                    <p>Are you sure you want to debit this mandate?</p>
                    <Form onSubmit={async (e) => {
                        e.preventDefault()
                        //   console.log("date ", date, "time ", time);
                        // toggle()
                        await handleUploadFile()
                        // setProceed(true)
                    }}>
                        <Form.Group>
                            <Form.Label>Name</Form.Label>
                            <Form.Control
                                required
                                // value={note}
                                onChange={(e) => setName(e.target.value)}
                            />
                        </Form.Group>
                        <Form.Group>
                            <Form.Label>Description</Form.Label>
                            <Form.Control
                                required
                                value={note}
                                onChange={(e) => setNote(e.target.value)}
                            />
                        </Form.Group>
                        <Form.Group>
                            <Form.Label>Channel</Form.Label>
                            <Form.Select
                                required
                                onChange={(e) => setChannel(e.target.value)}
                            >
                                <option value="">Select a channel</option>
                                {channelsAvailable.map((n, index) => (
                                    <option key={index} value={n}>
                                        {n}
                                    </option>
                                ))}
                            </Form.Select>
                        </Form.Group>
                        
                        <Form.Group>
                            <Form.Label>Template type</Form.Label>
                            <Form.Select
                                required
                                onChange={(e) => setTemplateType(e.target.value)}
                            >
                                <option value="">Select a template type</option>
                                {allTemplates.map((n, index) => (
                                    <option key={index} value={n?.type}>
                                        {n?.name}
                                    </option>
                                ))}
                            </Form.Select>
                        </Form.Group>
                        <Form.Group>
                            <Form.Label>Schedule type</Form.Label>
                            <Form.Select
                                required
                                onChange={(e) => setScheduleType(e.target.value)}
                            >
                                <option value="">Select a schedule type</option>
                                {scheduleAvailable.map((n, index) => (
                                    <option key={index} value={n}>
                                        {n}
                                    </option>
                                ))}
                            </Form.Select>
                        </Form.Group>
                        {scheduleType == "later" &&
                        <Form.Group>
                            <Form.Label>Schedule mins</Form.Label>
                            <Form.Control
                                type="number"
                                required
                                onChange={(e) => setScheduleMins(e.target.value)}
                            />
                        </Form.Group>
                        }
                        {scheduleType == "specific" && <div>
                        <Form.Group>
                            <Form.Label>Date</Form.Label>
                            <Form.Control
                                type="date"
                                required
                                value={date}
                                onChange={(e) => setDate(e.target.value)}
                            />
                        </Form.Group>

                        <Form.Group>
                            <Form.Label>Time</Form.Label>
                            <Form.Control
                                type="time"
                                required
                                value={time}
                                onChange={(e) => setTime(e.target.value)}
                            />
                        </Form.Group>
                        </div>}

                        <Form.Group>
                            <Form.Label>File</Form.Label>
                            <Form.Control
                                type="file"
                                required
                                onChange={handleFileChange}
                            />
                        </Form.Group>


                        <div style={{ padding: "16px", display: "flex", justifyContent: "flex-end" }}>
                            <Button
                                type="submit"
                                style={{
                                    // backgroundColor: "red",
                                    fontSize: "0.8rem",
                                    fontWeight: 500,
                                    border: 0,
                                }}

                            //   disabled={isUpdating}
                            >
                                Proceed
                            </Button>
                        </div>
                    </Form>
                </Modal.Body>

            </div>}
        </Modal>
    );
};
